import React from 'react';
import { ArrowUpRightIcon, FileTextIcon } from 'lucide-react';
import { certificates, qualifications } from '../data/recognition';
export function Qualifications() {
  return <div data-id="element-198" data-mp="1gv5rnvcdgtwa">
      <ul className="grid gap-x-10 md:grid-cols-2" data-id="element-199" data-mp="1gvntr8lpu2c4">
        {qualifications.map(q => <li key={q.title} className="flex items-baseline justify-between gap-6 border-t border-rule py-4" data-id="element-200" data-mp="1bwaxjx8yfiwv">
            <div data-id="element-201" data-mp="o5ysqv90a2ai">
              <h3 className="font-serif text-lg text-forest" data-id="element-202" data-mp="o7i6of76w194">{q.title}</h3>
              <p className="mt-0.5 text-sm text-charcoal-muted" data-id="element-203" data-mp="k5evlrofmyod">{q.issuer}</p>
            </div>
            <p className="shrink-0 text-sm tabular-nums text-charcoal" data-id="element-204" data-mp="xw06ou7na4bp">{q.year}</p>
          </li>)}
      </ul>

      <section aria-labelledby="certificates-title" className="mt-16" data-id="element-205" data-mp="t5bax2oxml6r">
        <h2 id="certificates-title" className="font-serif text-2xl text-forest" data-id="element-206" data-mp="5fz3a7996l6k">
          Original certificates
        </h2>
        <p className="mt-2 max-w-2xl text-sm leading-relaxed text-charcoal-muted" data-id="element-207" data-mp="hnw64aceos1">
          Scanned copies of the originals. Each opens as a PDF in a new tab.
        </p>

        <ul className="mt-8 grid gap-4 md:grid-cols-2" data-id="element-208" data-mp="218e8swnsirvy">
          {certificates.map(c => <li key={c.id} data-id="element-209" data-mp="25ze2zu5iyvur">
              <article className="flex h-full flex-col rounded-xl border border-rule bg-cream-deep p-6" data-id="element-210" data-mp="25z4ds8sb0sq4">
                <div className="flex items-start gap-4" data-id="element-211" data-mp="2axfosmuc599x">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-wheat bg-wheat-soft" data-id="element-212" data-mp="1dap1hu0k4oih">
                    <FileTextIcon className="h-5 w-5 text-wheat-dark" aria-hidden="true" data-id="element-213" data-mp="1iauw9j24ir4s" />
                  </span>
                  <div className="min-w-0" data-id="element-214" data-mp="1n83ipvub1hbu">
                    <h3 className="font-serif text-lg leading-snug text-forest" data-id="element-215" data-mp="1rahyg72og0yw">{c.title}</h3>
                    <p className="mt-0.5 text-sm text-charcoal-muted" data-id="element-216" data-mp="1r85b1ee5gyeg">{c.issuer}</p>
                  </div>
                </div>
                <p className="mb-5 mt-4 text-sm leading-relaxed text-charcoal" data-id="element-217" data-mp="32p3uiqilyxjs">{c.citation}</p>
                <div className="mt-auto flex items-center justify-between gap-4 border-t border-rule pt-4" data-id="element-218" data-mp="13kdl4kd3j0ms">
                  <p className="text-sm tabular-nums text-charcoal-muted" data-id="element-219" data-mp="ymljgymng05e">{c.date}</p>
                  <a href={c.url} target="_blank" rel="noreferrer" aria-label={`View certificate: ${c.title} (PDF)`} className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-cyan transition-colors duration-150 hover:text-forest focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-forest" data-id="element-220" data-mp="1cm3cxraw41l3">
                    View certificate
                    <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-221" data-mp="ouxwb9x4l59q" />
                  </a>
                </div>
              </article>
            </li>)}
        </ul>
      </section>
    </div>;
}